import api, { armorAPI } from '~/services/api';
import { type JSONTransaction } from '~/types/Transaction';

const get = (transactionObjectId: string) =>
  api.request<JSONTransaction>({
    method: 'GET',
    url: `/transactions/${transactionObjectId}`,
  });

const emailNotify = (transactionObjectIds: string[]) =>
  armorAPI.request({
    data: {
      transactions: transactionObjectIds,
    },
    method: 'POST',
    url: '/email',
  });

const refund = (transactionObjectId: string) =>
  api.request({
    data: {
      transaction: transactionObjectId,
    },
    method: 'POST',
    url: `refunds/`,
  });

export { emailNotify, get, refund };
